import { ThemeProvider, createTheme } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import OverwriteMomentBE from "../OverwriteMomentBE";

interface DatePickerProps {
    label: string;
    emptyLabel: string;
    inputVariant: "standard" | "outlined" | "filled";
    selectedDate: null | moment.Moment;
    disabled: boolean;
    setSelectedDate: (date: any) => void;
    required?: boolean;
    style?: React.CSSProperties;
    clearable?: boolean;
}

const datePickerTheme = createTheme({
    palette: {
        primary: {
            main: '#005BAE',
        },
    },
    typography: {
        fontFamily: 'Sarabun',
    },
});

export default function DatePickerInput({ label, emptyLabel, inputVariant, selectedDate, disabled, setSelectedDate, required, style, clearable }: DatePickerProps) {

    return (
        <>
            <ThemeProvider theme={datePickerTheme}>
                <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
                    <div className="DatePicker">
                    <DatePicker
                        views={["year", "month", "date"]}
                        label={label}
                        emptyLabel={emptyLabel}
                        disabled={disabled}
                        inputVariant={inputVariant}
                        value={selectedDate}
                        format="DD MMM YYYY"
                        onChange={date => {
                            setSelectedDate(moment(date))
                        }}
                        fullWidth
                        required={required}
                        inputProps={{
                            style: {...style}
                        }}
                    />
                    { clearable && selectedDate && <button className="DatePicker-clear-btn" type='button' onClick={() => setSelectedDate(null)} disabled={disabled}>Clear</button>}
                    </div>
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </>
    )
}